import React, { useEffect, useState } from "react";
import { DashboardShell } from "@/components/DashboardLayout";
import { BackButton } from "@/components/Layout";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api, fmtSASTDateTime, fmtZAR } from "@/lib/api";

export default function MerchantHistory() {
  const [vouchers, setVouchers] = useState([]);

  useEffect(() => {
    api.get("/vouchers").then(({ data }) => setVouchers(data.vouchers || []));
  }, []);

  return (
    <DashboardShell role="merchant">
      <BackButton to="/dashboard" />
      <p className="text-xs tracking-[0.22em] uppercase font-bold text-[#00C4B4]">History</p>
      <h1 className="font-display mt-2 text-3xl font-bold text-[#0A2540]">Voucher transactions</h1>

      <div className="mt-6 bg-white border border-[#E5E7EB] rounded-2xl overflow-hidden">
        <Table data-testid="voucher-history-table">
          <TableHeader>
            <TableRow>
              <TableHead>Created</TableHead>
              <TableHead>PIN</TableHead>
              <TableHead>Service</TableHead>
              <TableHead>Original</TableHead>
              <TableHead>Balance</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {vouchers.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-[#666666] py-8">No vouchers yet</TableCell></TableRow>}
            {vouchers.map((v) => (
              <TableRow key={v.id}>
                <TableCell className="text-xs">{fmtSASTDateTime(v.created_at)}</TableCell>
                <TableCell className="font-mono text-sm">{v.pin_masked}</TableCell>
                <TableCell className="text-xs uppercase">{v.intended_service}</TableCell>
                <TableCell className="font-mono">{fmtZAR(v.original_amount)}</TableCell>
                <TableCell className="font-mono font-semibold text-[#00C853]">{fmtZAR(v.balance)}</TableCell>
                <TableCell><span className="text-xs uppercase text-[#0A2540]">{v.status.replace("_", " ")}</span></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </DashboardShell>
  );
}
